export const PALETTE = {
  femaleGradient: "linear-gradient(179.99deg, #ED304D 25.17%, #0C029F 99.99%)",
  maleGradient: "linear-gradient(179.99deg,#0C029F 25.17%,  #ED304D 99.99%)",
  primary: "#ECEDF5",
  secondary: "#9895A9",
  third: "#7B7B7B",
  fourth: "#68618F",
  fifth: "#E2E4F1",
  sixth: "#898a8b",
  seventh: "#0EE8B6",
  eightth: "#4C466F",
  ninth: "#FF0000",
  light_pink: "#F9B5CD",
  pink: "#FB83AC",
  dark_pink: "#E8447D",
  black: "#000000",
  white: "#FFFFFF",
  Status: {
    chips: [
      {
        background: "#D7FFF5",
        font: "#099877",
      },
      {
        background: "#8BF8DE",
        font: "#099877",
      },
      {
        background: "#63DCC0",
        font: "#0D6D57",
      },
    ],
    gray: "#8aa9a2",
  },
};
